module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.refund !== null && _vm.order !== null) ? _c('span', [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("\r\n          Retour #" + _vm._s(_vm.refund.id) + "\r\n          "), _c('refund-status-badge', {
    attrs: {
      "refund": _vm.refund
    }
  })], 1)]), _vm._v(" "), _c('order-timeline', {
    attrs: {
      "order": _vm.order
    }
  })], 1), _vm._v(" "), _c('order-address', {
    attrs: {
      "order": _vm.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table table-borderless table-striped table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.orderLines), function(line) {
    return _c('tr', {
      key: line.id
    }, [(line.product) ? _c('td', [_c('a', {
      staticClass: "font-w600",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(line.product.gtin))])]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.product.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(line.quantity) + " X " + _vm._s(line.product_price))]), _vm._v(" "), _c('td', [(_vm.refund.status !== 'completed') ? _c('div', {
      staticClass: "row"
    }, [_c('input', {
      ref: "input",
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "id": line.id,
        "type": "number",
        "value": "0",
        "min": "0",
        "max": line.quantity
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-noborder",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.updateAmountOfProductRefunded(line)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])]) : _c('div', [_vm._v(" " + _vm._s(_vm.amountRefundedValue(line.product.id)) + " ")])]), _vm._v(" "), _c('td', [(_vm.refund.status !== 'completed') ? _c('div', {
      staticClass: "row"
    }, [_c('input', {
      ref: "quantityInput",
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "id": line.id,
        "type": "number",
        "max": line.quantity
      }
    })]) : _c('div', [_vm._v(" " + _vm._s(_vm.stockIncreaseValue(line.product.id)) + " ")])]), _vm._v(" "), _c('td', [(_vm.refund.status !== 'completed' && !_vm.isFromMarketPlace) ? _c('div', {
      staticClass: "row"
    }, [_c('input', {
      ref: "priceInput",
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "id": line.id,
        "type": "number"
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-noborder",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.updateProductPrice(line)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])]) : _c('div', [_vm._v(" " + _vm._s(_vm.discountValue(line.product.id)) + "% ")])])])
  }), 0)])])]), _vm._v(" "), (_vm.refund.status !== 'completed' && !_vm.isFromMarketPlace) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('div', [_c('label', {
    staticClass: "css-control css-control-primary css-checkbox",
    attrs: {
      "for": "orderStatus"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderStatus),
      expression: "orderStatus"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox",
      "id": "orderStatus",
      "name": "orderStatus",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.orderStatus) ? _vm._i(_vm.orderStatus, "true") > -1 : (_vm.orderStatus)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.orderStatus,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.orderStatus = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.orderStatus = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.orderStatus = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Bestelling status op compleet zetten?\r\n            ")])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "css-control css-control-primary css-checkbox",
    attrs: {
      "for": "refundMail"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendRefundConformationMail),
      expression: "sendRefundConformationMail"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox",
      "id": "refundMail",
      "name": "refundMail",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.sendRefundConformationMail) ? _vm._i(_vm.sendRefundConformationMail, "true") > -1 : (_vm.sendRefundConformationMail)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sendRefundConformationMail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sendRefundConformationMail = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sendRefundConformationMail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sendRefundConformationMail = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Retour bevestiging mail sturen?\r\n            ")])]), _vm._v(" "), _c('div', [(_vm.includeRefundShipmentCosts) ? _c('label', {
    staticClass: "css-control css-control-primary css-checkbox",
    attrs: {
      "for": "calculateRefundShipmentCosts"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculateRefundShipmentCosts),
      expression: "calculateRefundShipmentCosts"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox",
      "id": "calculateRefundShipmentCosts",
      "name": "calculateRefundShipmentCosts",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.calculateRefundShipmentCosts) ? _vm._i(_vm.calculateRefundShipmentCosts, "true") > -1 : (_vm.calculateRefundShipmentCosts)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.calculateRefundShipmentCosts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.calculateRefundShipmentCosts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.calculateRefundShipmentCosts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.calculateRefundShipmentCosts = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Retour Kosten: " + _vm._s(_vm.refundShippingCost) + ",-\r\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.includeRefundShipmentCosts) ? _c('label', {
    staticClass: "css-control css-control-primary css-checkbox",
    attrs: {
      "for": "orderShipmentCosts"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeOrderShipmentCosts),
      expression: "includeOrderShipmentCosts"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox",
      "id": "orderShipmentCosts",
      "name": "orderShipmentCosts",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeOrderShipmentCosts) ? _vm._i(_vm.includeOrderShipmentCosts, "true") > -1 : (_vm.includeOrderShipmentCosts)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeOrderShipmentCosts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeOrderShipmentCosts = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeOrderShipmentCosts = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeOrderShipmentCosts = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Verzend Kosten: " + _vm._s(_vm.orderShippingCost) + "\r\n          ")]) : _vm._e(), _vm._v(" "), (_vm.includeOrderShipmentCosts) ? _c('p', [_c('span', [_vm._v("Verzend kosten ")]), _vm._v(" "), _c('exclude-toggle', {
    model: {
      value: (_vm.incrementOrderShimentCosts),
      callback: function($$v) {
        _vm.incrementOrderShimentCosts = $$v
      },
      expression: "incrementOrderShimentCosts"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" totaal bedrag")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "retourInput"
    }
  }, [_vm._v("Vul handmatig een (extra) retourbedrag in")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.manualRefundPrice),
      expression: "manualRefundPrice",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "0",
      "name": "retourInput"
    },
    domProps: {
      "value": (_vm.manualRefundPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.manualRefundPrice = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), (_vm.refund != null) ? _c('div', {
    staticClass: "block block-bordered"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "bg-light rounded d-flex flex-column"
  }, [_c('div', {
    staticClass: "p-2 d-flex"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("Geretourneerde producten prijs: ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v("+ " + _vm._s(Math.round((_vm.totalRefundPrice) * 100) / 100))])]), _vm._v(" "), _c('div', {
    staticClass: "p-2 d-flex"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("Handmatig (extra) retourbedrag")]), _vm._v(" "), (Math.sign(_vm.manualRefundPrice) === 1) ? _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v("+ " + _vm._s(_vm.manualRefundPrice))]) : _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v(_vm._s(_vm.manualRefundPrice))])]), _vm._v(" "), _c('div', {
    staticClass: "p-2 d-flex"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("Verzendkosten")]), _vm._v(" "), (_vm.incrementOrderShimentCosts) ? _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v("+ " + _vm._s(_vm.orderShippingCost))]) : _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v("- " + _vm._s(_vm.orderShippingCost))])]), _vm._v(" "), (_vm.includeRefundShipmentCosts && _vm.calculateRefundShipmentCosts) ? _c('div', {
    staticClass: "p-2 d-flex"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("Retour Kosten")]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_vm._v("- " + _vm._s(_vm.refundShippingCost))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "border-top px-4 mx-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-2 d-flex pt-3"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('b', {
    staticClass: "green"
  }, [_vm._v("€ " + _vm._s(_vm.calculateTotalRefundCost))])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.refund.status !== 'completed') ? _c('div', {
    staticClass: "p-2 d-flex pt-3"
  }, [_c('button', {
    staticClass: "btn btn-hero btn-alt-success",
    staticStyle: {
      "margin-right": "0px"
    },
    on: {
      "click": _vm.updateRefundPrice
    }
  }, [_vm._v("Retour verwerken")])]) : _vm._e(), _vm._v(" "), (_vm.refund.status === 'completed' && !_vm.isFromMarketPlace) ? _c('div', {
    staticClass: "p-2 d-flex pt-3"
  }, [_c('div', {
    staticClass: "border-top px-4 mx-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('b', {
    staticClass: "green"
  }, [_vm._v("Totaal terug geboekt bedrag: € " + _vm._s(_vm.refund.refund_cost))])])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Producten")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("EAN")]), _vm._v(" "), _c('th', [_vm._v("Product")]), _vm._v(" "), _c('th', [_vm._v("Aantal geleverd")]), _vm._v(" "), _c('th', [_vm._v("Aantal geretourneerd")]), _vm._v(" "), _c('th', [_vm._v("Voorraad toename")]), _vm._v(" "), _c('th', [_vm._v("Korting (in procenten)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Afrekenen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-8"
  }, [_c('b', [_vm._v("Totaal")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46308c3a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/refunds/RefundForm.vue
// module id = 711
// module chunks = 1